"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Icon_1 = __importDefault(require("../Icon"));
// wait time before the loader shows
var DELAY_TIME = 1000;
function ImageLoader() {
    var _a = (0, react_1.useState)(false), visible = _a[0], setVisible = _a[1];
    (0, react_1.useEffect)(function () {
        var timeout = setTimeout(function () {
            setVisible(true);
        }, DELAY_TIME);
        return function () { return clearTimeout(timeout); };
    }, []);
    if (!visible)
        return null;
    return (react_1.default.createElement(StyledIcon, { name: 'ff-icon-logo', fontSize: 100 }));
}
exports.default = ImageLoader;
var StyledIcon = (0, styled_1.default)(Icon_1.default)({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '@keyframes flash': {
        '0%': {
            color: 'black',
        },
        '100%': {
            color: 'white',
        },
    },
    opacity: 0.5,
    animationDuration: '3000ms',
    animationTimingFunction: 'ease-in-out',
    animationDirection: 'alternate',
    animationName: 'flash',
    animationIterationCount: 'infinite'
});
